import React from 'react'
import classNames from 'classnames'
import styles from './styles.module.scss'

type FlashBannerDiscountProps = {
  discountLabel: string
  discount: string
  center: boolean
}

function FlashBannerDiscount({
  discountLabel,
  discount,
  center
}: Partial<FlashBannerDiscountProps>) {
  const classes = classNames(styles.flashDiscount, {
    [styles.flashDiscount_center]: !center
  })
  return !!discountLabel || !!discount ? (
    <div className={classes}>
      <p className={styles.flashDiscount__label}>{discountLabel}</p>
      <p className={styles.flashDiscount__code}>{discount}</p>
    </div>
  ) : null
}

export default FlashBannerDiscount
